module.exports = __webpack_public_path__ + "static/img/cetrify.2633ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trialCenter/cetrify.png
// module id = y177
// module chunks = 113